import React from 'react';

import Authenticated from '~layouts/Authenticated/Authenticated';
import ErrorBoundary from '~layouts/ErrorBoundary/ErrorBoundary';
import Unauthenticated from '~layouts/Unauthenticated/Unauthenticated';
import Error404 from '~pages/Error404/Error404';
import { PRIVATE_ROUTES, PUBLIC_ROUTES, ROUTES } from './routesDictionary';

type PageProps = Error404Props;

// Union type for all possible route configurations
export type RouteConfig = { route: string; index?: boolean } & (
  | {
      component: React.ComponentType<PageProps>;
      props: PageProps;
    }
  | {
      component: React.ComponentType<Record<string, never>>;
      props?: never;
    }
);

// Helper function to create routes from an array with ErrorBoundary
const createRoutesFromArray = (
  routesArray: RouteConfig[],
  type: 'PUBLIC' | 'PRIVATE'
) => {
  return routesArray.map((routeConfig) => {
    return {
      path: routeConfig.route,
      index: routeConfig.index,
      element: (
        <ErrorBoundary
          key={routeConfig.route}
          fallback={<Error404 fullscreen={type === 'PUBLIC'} />}
        >
          {routeConfig.props ? (
            <routeConfig.component {...routeConfig.props} />
          ) : (
            <routeConfig.component />
          )}
        </ErrorBoundary>
      )
    };
  });
};

export const ALL_ROUTES = [
  {
    path: ROUTES.ROOT,
    element: <Unauthenticated />,
    children: createRoutesFromArray(PUBLIC_ROUTES, 'PUBLIC')
  },
  {
    path: ROUTES.PLATFORM,
    element: <Authenticated />,
    children: createRoutesFromArray(PRIVATE_ROUTES, 'PRIVATE')
  }
];
